import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { inject, ref } from 'vue'
import { plantsApi } from '@/di/api'
import { EVENT_NAME__PLANT_TRANSLATED } from '@/api/PlantsApi'
import eventBus from '@/di/eventBus'
import AppIconLoadingButton from "@/components/app/AppIconLoadingButton.vue";
import { notifyInjectionKey } from "@/keys";

interface Props {
  id: string,
  type?: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PlantTranslate',
  props: {
    id: null,
    type: { default: 'plant' }
  },
  emits: ["translated"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'translated'): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as { id: string, type: string };

const notify = inject(notifyInjectionKey)





if (!['plant'].includes(props.type)) throw new Error(`Type '${props.type}' is not supported for translation`)

const lock = ref<{ requestSending: boolean }>({ requestSending: false })

async function translate (): Promise<void> {
  lock.value.requestSending = true

  try {
    await plantsApi.translatePlant(props.id)

    eventBus.$once(EVENT_NAME__PLANT_TRANSLATED, () => emit('translated'))

    notify?.({ text: 'Translation scheduled' })
  } catch (e) {
    notify?.({ text: 'Error on request' })
  } finally {
    lock.value.requestSending = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppIconLoadingButton, {
    loading: lock.value.requestSending,
    icon: "language",
    "button-small": true,
    onClick: translate
  }, null, 8, ["loading"]))
}
}

})